import { Breadcrumb, styled } from '@fluentui/react';
import { getBreadcrumbStyles } from './m365-breadcrumb.style';
export const M365Breadcrumb = styled(Breadcrumb, getBreadcrumbStyles, undefined, { scope: 'M365Breadcrumb' });
//# sourceMappingURL=m365-breadcrumb.js.map